export default __webpack_public_path__ + "static/media/kb.d1f25184.png";